
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 2118 1921.8"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"escena_x5F_path"}},[_c('path',{attrs:{"id":"escenario_x5F_3_x5F_path","d":"M2116.7 609.9L1059.4.3 2 610.8l.1 697.6 1057.4 610.5 1057.2-610.5V609.9z","opacity":".15","fill":"#fff"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_09","fill":"rgb(10,10,10,0.2)","d":"M1694.6 924.4h311.2v291.3h-311.2z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_10","fill":"rgb(10,10,10,0.2)","d":"M458.8 963.7H781v255.1H458.8z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_11","fill":"rgb(10,10,10,0.2)","d":"M1446.5 434.7h289.1v341.6h-289.1z"}})])])
          )
        }
      }
    